import {Timestamp} from '@angular/fire/firestore';

/**
 * Interface representing a temporary stock update notification.
 */
export interface IStockUpdate {
  executed: Timestamp;
  generated: Timestamp;
  orderId: string;
}
